import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@ui5/webcomponents-react";
import { Toaster } from "sonner";

import "@ui5/webcomponents-icons/dist/AllIcons.js";
import "./index.css";
import App from "./App";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </ThemeProvider>
  </React.StrictMode>
);
